import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faSearch,
  faArrowRight,
  faChevronLeft,
  faChevronRight,
  faCommentDots,
  faPenToSquare,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import { getAllEmploymentData, deleteEmployment } from '../../../services/candidate/api';
import './employment-details.css';

const EmploymentDetails = ({ onNext, onBack ,onClose,isSuccess}) => {
  const navigate = useNavigate();
  const [employmentData, setEmploymentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
   const [showPopup, setShowPopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    fetchEmploymentData();
  }, []);

  const fetchEmploymentData = async () => {
    try {
      setLoading(true);
      const response = await getAllEmploymentData();
      setEmploymentData(response || []);
    } catch (err) {
      setError(`Failed to load employment data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = async () => {
    try {
      await deleteEmployment(deleteId);
      fetchEmploymentData(); // refresh list
    } catch (err) {
      alert("Failed to delete record.");
      console.error("Delete error:", err);
    } finally {
      setShowPopup(false);
      setDeleteId(null);
    }
  };

  const handleDelete = async (id) => {
    // const confirmDelete = window.confirm('Are you sure you want to delete this employment record?');
    // if (!confirmDelete) return;

 setDeleteId(id);
    setShowPopup(true);

    // try {
    //   await deleteEmployment(id);
    //   fetchEmploymentData(); // Refresh list after delete
    // } catch (err) {
    //   alert('Failed to delete record.');
    //   console.error('Delete error:', err);
    // }finally {
    //   setShowPopup(false);
    //   setDeleteId(null);
    // }
  };
  const cancelDelete = () => {
    setShowPopup(false);
    setDeleteId(null);
  };
  const handlePrevious = () => {
    onBack ? onBack() : navigate('/candidate/education-info/high-school');
  };

  const handleProceed = () => {
    onNext ? onNext() : navigate('/candidate/declaration');
  };

  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const filteredData = employmentData.filter((emp) =>
    emp.companyName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    emp.jobTitle?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalEntries = filteredData.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    
    
    <div className="emp-page">
      <div className="emp-content-area">
        <h2 className="emp-heading">Employment Details</h2>
        <div className="emp-note">
          <strong>NOTE:</strong> If you are a fresher please skip this page and proceed to Declaration.
      
        </div>

        <div className="emp-add-section">
          <button className="emp-add-button" onClick={() => navigate('/candidate/new-employment')}>
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: '6px' }} />
            Add New Employment
          </button>
        </div>

        <div className="emp-table-container">
          <div className="table-controls">
            <div className="show-entries">
              Show
              <select onChange={handleEntriesChange} value={entriesPerPage}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              entries
            </div>

            <div className="search-box">
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearch}
              />
              <button>
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
          </div>

          <table className="emp-data-table">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Job Title</th>
                <th>Working From</th>
                <th>Working To</th>
                <th>Contact Number</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((emp) => (
                  <tr key={emp.id}>
                    <td>{emp.companyName || 'N/A'}</td>
                    <td>{emp.jobTitle || 'N/A'}</td>
                    <td>{formatDate(emp.workingFrom)}</td>
                    <td>{formatDate(emp.workingTo)}</td>
                    <td>{emp.hrContactNumber || 'N/A'}</td>
                    <td className="candidate-actions">
                      <button
                        onClick={() => navigate(`/candidate/edit-employment/${emp.id}`)}
                        className="candidate-action-button edit"
                        title="Edit"
                      >
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </button>
                      <button
                        className="candidate-action-button delete"
                        title="Delete"
                        onClick={() => handleDelete(emp.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">Add New Employment to view or Edit Data</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="table-footer">
            <span>
              Showing {startIndex + 1} to {Math.min(endIndex, totalEntries)} of {totalEntries} entries
            </span>
            <div className="pagination">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={currentPage === index + 1 ? 'active' : ''}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="empButtonGroup">
        <button className="empButton" onClick={handleProceed}>
          Proceed to Declare <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>

 

       {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2 className="popup-title">Confirmation</h2>
            <p>Are you sure you want to delete this employment record?</p>
            <button onClick={confirmDelete} className="popup-ok-btn">
              OK
            </button>
            <button onClick={cancelDelete} className="popup-cancel-btn">
              Cancel
            </button>
          </div>
        </div>
      )}


    </div>



  );
};

export default EmploymentDetails;
